import React, { useState } from 'react';
import { FaLanguage, FaSpinner, FaCheck, FaTimes } from 'react-icons/fa';
import translationService from '../../../services/translationService';
import styles from './TranslationButton.module.css';

const TranslationButton = ({ 
  text, 
  onTranslate, 
  disabled = false,
  className = '',
  size = 'medium'
}) => {
  const [isTranslating, setIsTranslating] = useState(false);
  const [translationStatus, setTranslationStatus] = useState(null);

  const handleTranslate = async () => {
    if (!text || !text.trim() || isTranslating) return;

    setIsTranslating(true);
    setTranslationStatus(null);

    try {
      const result = await translationService.translateFromArabic(text);
      
      if (result.success) {
        setTranslationStatus('success');
        onTranslate(result.translations);
      } else {
        setTranslationStatus('error');
        console.error('Translation failed:', result.error);
      }
    } catch (error) {
      setTranslationStatus('error');
      console.error('Translation error:', error);
    } finally {
      setIsTranslating(false);
    }
  };

  const isArabic = translationService.isArabicText(text);
  const canTranslate = text && text.trim() && isArabic && !disabled;

  return (
    <button
      type="button"
      className={`${styles.translationButton} ${styles[size]} ${className} ${
        !canTranslate ? styles.disabled : ''
      }`}
      onClick={handleTranslate}
      disabled={!canTranslate || isTranslating}
      title={isArabic ? 'Translate to English and Turkish' : 'Text is not in Arabic'}
    >
      {isTranslating ? (
        <FaSpinner className={styles.spinner} />
      ) : translationStatus === 'success' ? (
        <FaCheck className={styles.success} />
      ) : translationStatus === 'error' ? (
        <FaTimes className={styles.error} />
      ) : (
        <FaLanguage />
      )}
      
      <span className={styles.buttonText}>
        {isTranslating ? 'Translating...' : 'Translate'}
      </span>
    </button>
  );
};

export default TranslationButton; 